// we must import directly from 'common/build/config' to ensure that we set the portal default config
// before anything else tries to read the config.
import { setPortalDefaultConfig } from 'common/build/config';

setPortalDefaultConfig({
    featureFlags: {},
});
